import { usePermissionsTableAgGridOptions } from "~/pages/UserAndRoles/CanopyRolesPage/CanopyRoleDetails/components/PermissionsTab/hooks";
import { RoleDetailsTable } from "~/pages/UserAndRoles/CanopyRolesPage/CanopyRoleDetails/components/RoleDetailsTable";
import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { useAgGridUtils } from "~/pages/UserAndRoles/utils/gridUtils";
import { WorkspaceRoleGroupNames } from "./consts";
import { useFetchWorkspacePermissions } from "./hooks";

type PermissionsTabProps = {
  roleName?: WorkspaceRoleGroupNames;
};

export const PermissionsTab = ({ roleName }: PermissionsTabProps) => {
  const { columnDefs } = usePermissionsTableAgGridOptions();
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      statusBar: {
        statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
      },
      overlayNoRowsTemplate: "No permissions found",
    },
  });
  const { onGridReady, resetFilters, isFilterPresent, onFilterChanged } = useAgGridUtils();
  const { rowData } = useFetchWorkspacePermissions(roleName);

  return (
    <RoleDetailsTable
      title="Permissions"
      columnDefs={columnDefs}
      rowData={rowData}
      gridOptions={gridOptions}
      onGridReady={onGridReady}
      resetFilters={resetFilters}
      isFilterPresent={isFilterPresent}
      onFilterChanged={onFilterChanged}
    />
  );
};
